import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    adminInfo: JSON.parse(localStorage.getItem('admin_info') || 'null')
  },
  mutations: {
    SET_TOKEN: function(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN_INFO: function(state, info) {
      state.adminInfo = info
      localStorage.setItem('admin_info', JSON.stringify(info))
    },
    LOGOUT: function(state) {
      state.token = ''
      state.adminInfo = null
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    }
  },
  getters: {
    isLoggedIn: function(state) { return !!state.token },
    adminInfo:  function(state) { return state.adminInfo }
  }
})